export default renderingCallback => {
  const isSupported = "requestIdleCallback" in window;
  return isSupported
    ? window.requestIdleCallback(renderingCallback, { timeout: 100 })
    : setTimeout(renderingCallback);
};
